import React from 'react';
import Article from '../../../../entities/article';

const Labels = ({
  article
}) => {
  const a = new Article({...article})
  return(
    <ul className="articleLabels isSmall">
      {a.is_promotion() &&  <li key='promotion' className='p_label isPromote'>注目</li>}
      {a.is_closing() &&  <li key='closing' className='p_label isGrey'>募集終了</li>}
      {a.is_pausing() && <li key='pausing' className='p_label isGrey'>受付停止中</li>}
      {(() =>{
        let working_forms: object[] = [];
        for(let i=0; i< a.working_form_or_kind!.length; i++){
          working_forms.push(<li key={'working_forms' + i} className='p_label isMain'>{a.working_form_or_kind![i]}</li>)
        }
        return working_forms
      })()}
      {a.is_new_arrival() && <li key='accent' className='p_label isAccent'>新着</li> }
      {a.deadline_text() && <li key='dead_line' className='p_label isDeadLine'>{a.deadline_text()}</li>}
      {<li key='update_date' className='p_label updated_date'>{a.updated_date}</li>}
    </ul>
  )
};

export default Labels;